<div class="main">
  <div class="section">
    <div class="sectionHeader">
      <div class="headerText">
        <div class="title">
          <div class="label">
            {{'ATTENDANCE.driverAttendance' | translate}}
          </div>
          <div class="help">
            <app-help [helpData]="helpData" ></app-help>
          </div>
        </div>
      </div>
      <div class="buttonSection">
        <div class="buttons" *ngIf="showButtons">
          <div class="button">
            {{'ATTENDANCE.assignShift' | translate}}
          </div>
        </div>
        <div class="buttons" *ngIf="showButtons">
          <div class="button">
            {{'ATTENDANCE.createSms' | translate}}
          </div>
        </div>
        <div class="buttons" *ngIf="showButtons">
          <div class="button">
            {{'ATTENDANCE.onDuty' | translate}}
          </div>
        </div>
        <div class="buttons" *ngIf="showButtons">
          <div class="button">
            {{'ATTENDANCE.offDuty' | translate}}
          </div>
        </div>
        <div class="buttons" *ngIf="showButtons">
          <div class="button">
            {{'ATTENDANCE.clear' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="table">
        <table mat-table [dataSource]='driversList'>
          <ng-container matColumnDef="checked">
            <th mat-header-cell *matHeaderCellDef>
              <div class="input">
                <mat-checkbox (change)="selectAllDrivers($event)">{{'ATTENDANCE.selectAll' | translate}}</mat-checkbox>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox (change)="showButtons=element.checked" [(ngModel)]="element.checked"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              <div class="input">
                <input type="text" [placeholder]="'ATTENDANCE.driverName' | translate">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              {{element.name}}
            </td>
          </ng-container>

          <ng-container matColumnDef="mobile">
            <th mat-header-cell *matHeaderCellDef>
              <div class="input">
                <input type="text" [placeholder]="'ATTENDANCE.mobile' | translate">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">                      
              {{element.mobile}}
            </td>
          </ng-container>

          <ng-container matColumnDef="shifts">
            <th mat-header-cell *matHeaderCellDef>
              <div class="input">
                <input type="text" [placeholder]="'ATTENDANCE.driverShifts' | translate">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <div *ngFor="let shift of element.shifts">
                <input type="text" value="{{shift.from}}" disabled="true" /> To <input type="text" value="{{shift.to}}" disabled="true" />
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="app_version">
            <th mat-header-cell *matHeaderCellDef>
              <div class="input">
                <input type="text" [placeholder]="'ATTENDANCE.appVersion' | translate">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">                      
              {{element.app_version}}
            </td>
          </ng-container>

          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef>
              <div class="input">
                <input type="text" [placeholder]="'ATTENDANCE.city' | translate">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">                      
              {{element.city}}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
              <div class="input">
                <input type="text" [placeholder]="'ATTENDANCE.status' | translate">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">                      
              <div class="buttons">
                  <div class="button on" *ngIf='element.status == "on"'>{{'ATTENDANCE.onDuty' | translate}}</div>
                  <div class="button off" *ngIf='element.status == "off"'>{{'ATTENDANCE.offDuty' | translate}}</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>
              <div class="input">
                <input type="text" [placeholder]="'ATTENDANCE.actions' | translate">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">                      
              <div class="buttons">
                <div class="button">
                  <span class="action">{{'ATTENDANCE.actions' | translate}}</span>
                  <i class="material-icons dropdown-icon">
                      arrow_drop_down
                    </i>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef='driverColumns; sticky:true;'></tr>
          <tr mat-row *matRowDef="let row; columns: driverColumns;"></tr>
        </table>
      </div>
    </div>
  </div>
</div>